/* eslint-disable */
/* global google */
import React from "react";
import mgreen from "../../common/images/map-pin-green.svg";
class Autocomplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = { orderHandled: "" };
  }

  componentDidMount() {
    var input = document.getElementById("pac-input");
    var options = {
      /*   types: ["(regions)"], */
      componentRestrictions: { country: "id" },
    };
    var autocomplete = new google.maps.places.Autocomplete(input, options);
    var currnetThis = this;
    autocomplete.addListener("place_changed", function () {
      document.getElementById("location-error").style.display = "none";
      var place = autocomplete.getPlace();
      var latitude = place.geometry.location.lat();
      var longitude = place.geometry.location.lng();
      var countryName = "";
      var cityName = "";
      var postalCode = "";
      var stateName = "";
      if (
        place.address_components !== "" &&
        typeof place.address_components !== undefined &&
        typeof place.address_components !== "undefined"
      ) {
        place.address_components.map((item) => {
          if (item.types !== "") {
            if (item.types.indexOf("country") >= 0) {
              countryName = item.long_name;
            }
            if (item.types.indexOf("locality") >= 0 && cityName === "") {
              cityName = item.long_name;
            }
            if (item.types.indexOf("postal_code") >= 0 && postalCode === "") {
              postalCode = item.long_name;
            }
            if (
              item.types.indexOf("administrative_area_level_1") >= 0 &&
              stateName === ""
            ) {
              stateName = item.long_name;
            }
          }
        });
      }
      if (cityName === "") {
        cityName = countryName;
      }

      var addressdetails =
        countryName +
        "~~" +
        latitude +
        "~~" +
        longitude +
        "~~" +
        cityName +
        "~~" +
        postalCode +
        "~~" +
        stateName;
      currnetThis.props.sateValChange("address", addressdetails);
    });
  }

  render() {
    return (
      <div className="pac-cardinfo" id="pac-card">
        <div id="pac-containerinfo">
          <input
            id="pac-input"
            placeholder="Search location..."
            name="location_address"
            type="text"
          />
          <img src={mgreen} className="pin-left" />
          <div id="location-error"></div>
        </div>
      </div>
    );
  }
}

export default Autocomplete;
